import { useState, useEffect } from "react";
import { Row, Col, Drawer, Select } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { withTranslation, TFunction } from "react-i18next";
import i18n from "i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  CustomNavLinkSmall,
  Outline,
  LanguageSelector,
} from "./styles";

const { Option } = Select;

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("intro");
  const history = useHistory();
  const location = useLocation();

  const handleScroll = () => {
    setScrolled(window.scrollY > 50);

    // Detectar seção ativa
    const sections = ["intro", "about", "product", "contact"];
    const scrollPosition = window.scrollY + 100;

    for (const sectionId of sections) {
      const element = document.getElementById(sectionId);
      if (element) {
        const offsetTop = element.offsetTop;
        const offsetBottom = offsetTop + element.offsetHeight;

        if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
          setActiveSection(sectionId);
          break;
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  // Desconta a altura do header fixo ao posicionar a seção
  const HEADER_OFFSET = 90;

  const smoothScrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (!element) return;
    const top = element.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
    window.scrollTo({ top, behavior: "smooth" });
  };

  // Ao vir de outra rota, a Home (e seus blocos lazy) ainda está montando:
  // espera a seção existir E o layout estabilizar antes de rolar, evitando
  // que o scroll caia no lugar errado por causa do carregamento assíncrono.
  const waitAndScroll = (id: string) => {
    let tries = 0;
    let lastTop = NaN;
    let stable = 0;
    const tick = () => {
      tries += 1;
      const element = document.getElementById(id);
      if (element) {
        const top = Math.round(element.getBoundingClientRect().top + window.scrollY);
        stable = top === lastTop ? stable + 1 : 0;
        lastTop = top;
        if (stable >= 2) {
          smoothScrollToSection(id);
          return;
        }
      }
      if (tries < 60) window.setTimeout(tick, 60);
    };
    tick();
  };

  const scrollTo = (id: string) => {
    setVisibility(false);
    if (location.pathname === "/" || location.pathname === "/home") {
      smoothScrollToSection(id);
    } else {
      history.push("/");
      waitAndScroll(id);
    }
  };

  const MenuItem = () => (
    <>
      <CustomNavLinkSmall
        onClick={() => scrollTo("about")}
        $isActive={activeSection === "about"}
      >
        {t("About")}
      </CustomNavLinkSmall>
      <CustomNavLinkSmall
        onClick={() => scrollTo("product")}
        $isActive={activeSection === "product"}
      >
        {t("Product")}
      </CustomNavLinkSmall>
      <CustomNavLinkSmall
        onClick={() => scrollTo("contact")}
        $isActive={activeSection === "contact"}
      >
        {t("Contact")}
      </CustomNavLinkSmall>
      <LanguageSelector>
        <Select defaultValue={i18n.language.slice(0, 2)} onChange={handleLanguageChange} aria-label={t("Idioma")}>
          <Option value="en">EN</Option>
          <Option value="pt">PT</Option>
          <Option value="es">ES</Option>
        </Select>
      </LanguageSelector>
    </>
  );

  return (
    <HeaderSection $scrolled={scrolled}>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <SvgIcon src="logo.svg" width="60px" height="64px" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton} style={{ padding: '2rem' }}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Burger onClick={toggleButton}>
              <Outline />
            </Burger>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
